var mp = mp || {};

// Price filter (noUiSlider)
//-----------------------------------------------------------------
mp.priceFilter = function ($context) {
  var $element = $("[data-price-filter]", $context || document);

  if (!$element.length || typeof noUiSlider === "undefined") {
    return;
  }

  $element.each(function () {
    var $this = $(this),
      slider = $this.find("[data-price-filter-slider]")[0],
      $from = $this.find("[data-price-filter-from]"),
      $to = $this.find("[data-price-filter-to]"),
      $minInput = $this.find('input[name="min_price"]'),
      $maxInput = $this.find('input[name="max_price"]'),
      min = parseInt($this.data("min"), 10),
      max = parseInt($this.data("max"), 10),
      currency = $this.data("currency");

    noUiSlider.create(slider, {
      start: [parseInt($this.data("from"), 10), parseInt($this.data("to"), 10)],
      connect: true,
      step: 1,
      margin: 1,
      range: { min: min, max: max },
    });

    // Update labels while dragging
    slider.noUiSlider.on("update", function (values) {
      $from.text(Math.round(values[0]) + " " + currency);
      $to.text(Math.round(values[1]) + " " + currency);
    });

    // Submit on release; values at the range edges are left out of the URL
    slider.noUiSlider.on("change", function (values) {
      var from = Math.round(values[0]),
        to = Math.round(values[1]);

      $minInput.val(from).prop("disabled", from <= min);
      $maxInput.val(to).prop("disabled", to >= max);

      $this.closest("form").trigger("submit");
    });
  });
};

// Shop listing without page reload (filters, Akcija, sorting, pagination)
// Fetches the listing page and swaps the product list, count, sidebar
// and the hidden fields of the top bar forms (Akcija, sorting) with the new ones
//-----------------------------------------------------------------
mp.shopFilters = function () {
  var $listing = $(".products--listing"),
    request = null;

  if (!$listing.length || !window.history || !window.DOMParser) {
    return;
  }

  function load(url, push) {
    if (request) {
      request.abort();
    }

    $listing.addClass("is-loading");

    var xhr = (request = $.ajax({ url: url, dataType: "html" }));

    xhr
      .done(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html"),
          $new = $(doc).find(".products--listing");

        // Unexpected response, fall back to a normal page load
        if (!$new.length) {
          window.location.href = url;
          return;
        }

        $listing.find(".total").replaceWith($new.find(".total"));
        $listing.find(".main").replaceWith($new.find(".main"));
        $listing.find(".sidebar--filters").replaceWith($new.find(".sidebar--filters"));

        var $newForms = $new.find(".products__actions form");
        $listing.find(".products__actions form").each(function (i) {
          var $newForm = $newForms.eq(i);

          $(this).find('input[type="hidden"]').remove();
          $(this).prepend($newForm.find('input[type="hidden"]'));

          // Sync Akcija checkbox and sort select (needed on back / forward)
          $(this)
            .find('input[type="checkbox"]')
            .each(function () {
              this.checked = $newForm.find('input[name="' + this.name + '"]').prop("checked");
            });

          $(this)
            .find("select")
            .each(function () {
              $(this).val($newForm.find('select[name="' + this.name + '"]').val());

              if ($(this).data("selectric")) {
                $(this).selectric("refresh");
              }
            });
        });

        var $sidebar = $listing.find(".sidebar--filters");
        mp.selectric($sidebar);
        mp.priceFilter($sidebar);

        $(document).trigger("yith_wcwl_init_after_ajax");
        $(document).trigger("shop_filters_updated");

        if (push) {
          window.history.pushState({ shopFilters: true }, "", url);
        }

        // Scroll back to the top of the listing if it's out of view
        var top = $listing.offset().top - 100;
        if ($(window).scrollTop() > top) {
          $("html, body").animate({ scrollTop: top }, 300);
        }
      })
      .fail(function (xhr, status) {
        if (status !== "abort") {
          window.location.href = url;
        }
      })
      .always(function () {
        // An aborted request must not end the loading state of the newer one
        if (request === xhr) {
          $listing.removeClass("is-loading");
          request = null;
        }
      });
  }

  // Sidebar filters, Akcija and sorting forms
  $(document).on("submit", ".products--listing form", function (e) {
    e.preventDefault();

    // Clean URL: no empty values (e.g. "Sve dimenzije"), no paged (back to page 1), boja[0] -> boja[]
    var params = $(this)
      .serializeArray()
      .filter(function (field) {
        return field.value !== "" && field.name !== "paged";
      })
      .map(function (field) {
        return { name: field.name.replace(/\[\d+\]$/, "[]"), value: field.value };
      });

    var query = $.param(params),
      url = window.location.pathname.replace(/\/page\/\d+\/?$/, "/") + (query ? "?" + query : "");

    load(url, true);
  });

  // Pagination
  $(document).on("click", ".products--listing .woocommerce-pagination a", function (e) {
    e.preventDefault();
    load(this.href, true);
  });

  // Back / forward between filtered states (ignore other history entries, e.g. #hash changes)
  window.history.replaceState({ shopFilters: true }, "", window.location.href);

  window.addEventListener("popstate", function (e) {
    if (e.state && e.state.shopFilters) {
      load(window.location.href, false);
    }
  });
};

// Filters drawer (phones)
// Adds a "Filtri" button to the listing bar; the sidebar opens as a full-screen
// drawer with a close bar and a "Prikaži proizvode" button (styles in _responsive.scss)
//-----------------------------------------------------------------
mp.filtersDrawer = function () {
  var $listing = $(".products--listing");

  if (!$listing.length || !$listing.find(".sidebar--filters form").length) {
    return;
  }

  var $toggle = $(
      '<button type="button" class="filters-toggle" aria-expanded="false">Filtri <span class="filters-toggle__count"></span></button>'
    ),
    $bar = $(
      '<div class="filters-drawer__bar"><h5 class="title">Filtri</h5><button type="button" class="filters-drawer__close" aria-label="Zatvori">&times;</button></div>'
    ),
    $footer = $('<div class="filters-drawer__footer"><button type="button" class="btn">Prikaži proizvode</button></div>');

  $listing.find(".products__actions").append($toggle);
  $listing.append($bar, $footer);

  function toggle(open) {
    $listing.toggleClass("filters-open", open);
    $toggle.attr("aria-expanded", open ? "true" : "false");
    $("body").toggleClass("locked", open);
  }

  // Number of active filters on the button, product count on the drawer button
  function update() {
    var $form = $listing.find(".sidebar--filters form"),
      count =
        $form.find('input[type="checkbox"]:checked').length +
        $form.find("select").filter(function () {
          return this.value !== "";
        }).length +
        ($form.find('input[name="min_price"]:not(:disabled), input[name="max_price"]:not(:disabled)').length ? 1 : 0),
      total = $.trim($listing.find(".total strong").first().text());

    $toggle.find(".filters-toggle__count").text(count || "");
    $footer.find(".btn").text("Prikaži proizvode" + (total ? " (" + total + ")" : ""));
  }

  $toggle.on("click", function () {
    toggle(true);
  });

  $bar.on("click", ".filters-drawer__close", function () {
    toggle(false);
  });

  $footer.on("click", ".btn", function () {
    toggle(false);
    $("html, body").animate({ scrollTop: $listing.offset().top - 100 }, 300);
  });

  $(document).on("keydown", function (e) {
    if (e.key === "Escape" && $listing.hasClass("filters-open")) {
      toggle(false);
    }
  });

  // Back to desktop layout: drawer closed
  $(window).on("resize", function () {
    if (window.innerWidth >= 820 && $listing.hasClass("filters-open")) {
      toggle(false);
    }
  });

  $(document).on("shop_filters_updated", update);
  update();
};
